// extracted by mini-css-extract-plugin
export var infoRow = "_sq-2";
export var labelContainer = "_sq-0";
export var rightInfo = "_sq-1";